// extracted by mini-css-extract-plugin
export default {"custom-date-groups":"CustomDateGroups_custom-date-groups__efdbN"};